import React from 'react';
import { useSearchSort } from '../../components/kitsters/useSearchSort';
import { updatedata } from '../../util/global';

const TableItem = ({ bundledata, bunresolveddata, fetchdata }) => {
  const { view, query, setQuery, sortKey, sortDir, toggleSort } = useSearchSort(bundledata);

  const updatebundledata = async (data) => {
    const comment = prompt("comment:");
    if (!comment || comment == "") {
      alert("Comment is required");
      return;
    }
    let currtag = bunresolveddata.find((item) =>  {
      return item.bundle_id == data.bundle_id;
    });
    if (!currtag) {
      currtag = bundledata.find((item) =>  {
        return item._id && item.bundle_id == data.bundle_id;
      });
    }

    const res = await updatedata({data:{datatype:"zohotagdata", comment:comment, ...data, _id:currtag ? currtag._id : null}});
    console.log(res);
    fetchdata();
  };

  const rows = [];
  const bunresolvedrows = [];
  for (let i = 0; i < view.length; i++) {
    const a = view[i];
    rows.push(
      <tr key={a._id || i}>
        <td>{a.date.substring(2).split("-").reverse().join("/")}</td>

        <td>{a.reference_number}</td>
        <td>{a.composite_item_name}</td>
        <td>{a.compositeitem.purchase_rate}</td>

        <td>{a.total}</td>
        <td>{a.comment}</td>
        <td style={{ width: '150px' }}>
          <a href="#" onClick={(e) => {e.preventDefault();updatebundledata({ bundle_id:a.bundle_id, status:"resolved"});}}>resolve</a> | 
          <a href={`https://books.zoho.in/app/60022040726#/inventory/assembly/${a.bundle_id}?filter_by=Status.All&per_page=200`} target="_blank">view</a>
        </td>
      </tr>
    );
  }

  for (let i = 0; i < bunresolveddata.length; i++) {
    const a = bunresolveddata[i];
    bunresolvedrows.push(
      <tr key={a._id || i}>
        <td>{a.date.substring(2).split("-").reverse().join("/")}</td>

        <td>{a.reference_number}</td>
        <td>{a.composite_item_name}</td>
        <td>{a.compositeitem.purchase_rate}</td>

        <td>{a.total}</td>
        <td>{a.status}</td>
        <td>{a.comment}</td>
        <td style={{ width: '150px' }}>
          <a href="#" onClick={(e) => {e.preventDefault();updatebundledata({bundle_id:a.bundle_id, status:"ok"});}}>unresolve</a> | 
          <a href={`https://books.zoho.in/app/60022040726#/inventory/assembly/${a.bundle_id}?filter_by=Status.All&per_page=200`} target="_blank">view</a>
        </td>
      </tr>
    );
  }

  const th = (key: string, label: string) => (
    <th className="th-sort" onClick={() => toggleSort(key)}>
      {label} {sortKey === key ? (sortDir === 'asc' ? '▲' : '▼') : ''}
    </th>
  );

  return (
    <>
      <input className="tbl-search" placeholder="Search…" value={query} onChange={e => setQuery(e.target.value)} />
      <table className="grid">
        <thead>
          <tr>
            {th('date', 'date')}

            {th('name', 'BUN')}
            {th('unit', 'Composite Item')}
            {th('unit', 'Control Price')}

            {th('unit', 'BUN Total')}
            {th('unit', 'Comment')}
            <th style={{ width: '30px' }}>action</th>
          </tr>
        </thead>
        <tbody>{rows}</tbody>
      </table>
      <hr/>
      <h3>Resolved BUN</h3>
      <table className="grid">
        <thead>
          <tr>
            {th('date', 'date')}

            {th('name', 'BUN')}
            {th('unit', 'Composite Item')}
            {th('unit', 'Control Price')}

            {th('unit', 'BUN Total')}
            {th('unit', 'Status')}
            {th('unit', 'Comment')}
            <th style={{ width: '30px' }}>action</th>
          </tr>
        </thead>
        <tbody>{bunresolvedrows}</tbody>
      </table>
    </>
  );
};

export default TableItem;
